import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NoteRecord } from '../../objects/note-record';
import { UsersService } from '../../service/entity-services/users.service';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.css'],
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatSnackBarModule
  ]
})
export class NotesComponent implements OnChanges {
  private usersService = inject(UsersService);
  private snackBar = inject(MatSnackBar);

  @Input() notes: NoteRecord[] = [];
  @Output() notesSaved = new EventEmitter<NoteRecord[]>();

  noteText = '';
  originalText = '';
  saving = false;
  lastSavedAuthor: string | null = null;
  lastSavedDate: string | null = null;

  get isDirty(): boolean {
    return this.noteText !== this.originalText;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notes']) {
      const current = this.notes;
      if (current && current.length > 0) {
        this.noteText = current[0].note || '';
        this.originalText = this.noteText;
        this.lastSavedAuthor = current[0].author || null;
        this.lastSavedDate = current[0].dateTimeStamp || null;
      } else {
        this.noteText = '';
        this.originalText = '';
        this.lastSavedAuthor = null;
        this.lastSavedDate = null;
      }
    }
  }

  save(): void {
    this.saving = true;

    this.usersService.currentUserEmail$.subscribe(email => {
      const now = new Date();
      const noteRecord = new NoteRecord();
      noteRecord.author = email || 'Unknown';
      noteRecord.dateTimeStamp = now.toISOString();
      noteRecord.note = this.noteText;

      this.notesSaved.emit([noteRecord]);
      this.originalText = this.noteText;
      this.lastSavedAuthor = noteRecord.author;
      this.lastSavedDate = noteRecord.dateTimeStamp;
      this.saving = false;
      this.snackBar.open('Notes saved', 'OK', { duration: 3000 });
    });
  }

  getFormattedDate(): string {
    if (!this.lastSavedDate) return '';
    const date = new Date(this.lastSavedDate);
    return date.toLocaleDateString('en-US', {
      month: 'short', day: 'numeric', year: 'numeric',
      hour: 'numeric', minute: '2-digit'
    });
  }
}
